var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-bar-track"},[_c('div',{staticClass:"progress-bar-fill",style:({ width: _vm.percentage + '%' })})])
}
var staticRenderFns = []

export { render, staticRenderFns }